import { RtVueModuleRouter } from '../RtVue.router';
import { RtVueApiRoutes } from 'RtExports/routes';
import { FileLogStatsIndexResponse } from 'RtModels';

export class FileLogStatsRouterClass extends RtVueModuleRouter<
	FileLogStatsIndexResponse,
	FileLogStatsIndexResponse,
	{}
> {
	constructor() {
		super('File Log Stats', 'fileLogStats', 'guardianFileLogStatsId', {});

		this.setPermissionsFromApiRoute(RtVueApiRoutes.FileLogStats);
	}

	public getProfileLabel(profile: FileLogStatsIndexResponse): string {
		return profile.guardianFileLogStatsId.toString();
	}
}

export const FileLogStatsRouter = new FileLogStatsRouterClass();
